import { GridPanelVm } from "../../panels/gridpanel-vm";
import { StateStoring } from "../settings/statestoring";
import { dx } from "../../devexpress/ui-options-types-wrapper";
import { ControlType } from "../../devexpress/controltype";

export class DebuggingPermissionsDialogGridVm extends GridPanelVm<any> {
	constructor() {
		super({ initialHeightPerc: 80 });

		this.applyGridOptions({
			dataSource: this.dataSource,
			stateStoring: StateStoring.createStateStoring(
				10,
				"DebuggingPermissions",
				true,
				ControlType.DataGrid
			),
			columns: [
				{
					caption: "Interne Id",
					dataField: "id",
					dataType: "number",
					width: 80
				},
				{
					caption: "Name",
					dataField: "name",
					dataType: "string",
				},
				{
					caption: "Beschreibung",
					dataField: "description",
					dataType: "string",
				},
				{
					caption: "Berechtigt",
					dataField: "granted",
					dataType: "boolean",
					width: 90,
					headerFilter: {
						dataSource: [{
							value: true,
							text: "berechtigt"
						}, {
							value: false,
							text: "nicht berechtigt"
						}]
					}
				}
			],
			scrolling: { mode: "virtual" },
			selection: { mode: "none" },
		} as dx.DataGridOptions);
	}

	public dataSource: KnockoutObservable<any> = ko.observable([]);
}